import templateUrl from '../ridesharing-template.html';
import assignIn from 'lodash/assignIn';

export const ridesharingMainComponent = {
    templateUrl,

    //binding title, details and onSubmit function
    bindings: {
        pageTitle: '@',
        details: '<',
        county: '<',
        onSubmit: '&',
        onPrevious: '&',
        disableButtons: '<',
        parentSlug: '@'
    },

    //controller for RidesharingMainComponent
    controller: class RidesharingMainComponent {
        constructor($state, $anchorScroll, ModalService, CompareObjectService) {
            'ngInject';

            this.$state = $state;
            this.$anchorScroll = $anchorScroll;
            this.modalService = ModalService;
            this.compareObjectService = CompareObjectService;
        }

        $onInit() {
            this.step = 1;
            this.isBasicInfoActive = true;
            this.isOperationInfoClassInActive = false;
            this.details = this.details || {
                basicInfo: {
					serviceArea: [],
					phone: [],
					name: "",
					url: "",
					image: "",
					email: ""
				},
                operationInfo: ''
            };
            this.saveData= angular.copy(this.details)
        }

        onSubmitBasicInfo(details) {
            this.$anchorScroll(() => $location.hash());
            this.isOperationInfoClassActive = true;
            this.isBasicInfoActive = false;
            this.step += 1;
            this.details = assignIn(this.details, details);
        }

        onSubmitOperationInfo(details) {
            this.$anchorScroll(() => $location.hash());
            this.isOperationInfoClassInActive = true;
            this.details = assignIn(this.details, details);
            this.onSubmit({
                $event: this.details
            });
        }

        onOperationInfoPrevious(details) {
            this.$anchorScroll(() => $location.hash());
            this.isBasicInfoActive = true;
			this.isOperationInfoClassActive = false;
            this.step -= 1;
            this.details = assignIn(this.details, details);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/ridesharing/ridesharing-main/ridesharing-main.component.js